import { render, staticRenderFns } from "./ClassroomDetailGroupNameReview.vue?vue&type=template&id=972d34e6&scoped=true"
import script from "./ClassroomDetailGroupNameReview.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailGroupNameReview.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailGroupNameReview.vue?vue&type=style&index=0&id=972d34e6&prod&lang=stylus&scoped=true"
import style1 from "./ClassroomDetailGroupNameReview.vue?vue&type=style&index=1&id=972d34e6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972d34e6",
  null
  
)

export default component.exports